export const decryptParams = async (encryptedPayload) => {
  const payload = JSON.parse(atob(encryptedPayload));
  const { salt, iv, data, ref } = payload;

  const encodedRule = new Uint8Array(ref);

  const keyMaterial = await crypto.subtle.importKey(
    "raw",
    encodedRule,
    "PBKDF2",
    false,
    ["deriveKey"]
  );

  const cryptoKey = await crypto.subtle.deriveKey(
    {
      name: "PBKDF2",
      salt: new Uint8Array(salt),
      iterations: 1000,
      hash: "SHA-256",
    },
    keyMaterial,
    {
      name: "AES-GCM",
      length: 256,
    },
    true,
    ["decrypt"]
  );

  const decryptedData = await crypto.subtle.decrypt(
    {
      name: "AES-GCM",
      iv: new Uint8Array(iv),
    },
    cryptoKey,
    new Uint8Array(data)
  );

  return JSON.parse(new TextDecoder().decode(decryptedData));
};
